// extracted by mini-css-extract-plugin
export default {"container":"comments_container__thybi","list":"comments_list__TkUud","comment":"comments_comment__xHdTn"};